import React from 'react'
import '../../FamilyCard/family-card.css'

const FamilyCard = (props) => {

    return(
        <div className="family-card" style={props.fam.familyWaveId === '' ? {backgroundColor: 'rgba(0, 0, 0, 0.03)'} : {backgroundColor: 'rgb(255, 255, 255)'}} >
            <div className="add-some-padding">
                {
                    props.fam.lessons.map((less, index2) => 
                        <div className="family-card__each-lesson-wrapper" key={less.id}>
                            <input className="manual-student-input" placeholder="Student's Name" value={less.studentName} id={`${less.id}1`} />
                            <div className="family-card__lesson-date">{props.month}/<input value={less.date} id={`${less.id}2`} className="lesson-date-input" />/22</div>
                            <select id={`${less.id}3`} value={less.lessonLength} className="family-card__lesson-length">
                                <option default value={0}>Length</option>
                                <option value="15">15 min</option>
                                <option value="30">30 min</option>
                                <option value="45">45 min</option>
                                <option value="60">60 min</option>
                            </select>
                        </div>
                    )
                }
                {props.fam.cancellations.length > 0 && <div className="lesson-header">Cancellations</div>}
                {
                    props.fam.cancellations.map((cancel, index2) => 
                        <div className="family-card__each-lesson-wrapper go-red" key={cancel.id}>
                            {cancel.enterNameManually || props.fam.listOfFamilyStudents < 1 ?
                            <input className="manual-student-input go-red" value={cancel.student} placeholder="Student" id={`${cancel.id}1`} /> :
                            <select className="choose-student-input-dropdown go-red"  value={cancel.student} placeholder="Student" id={`${cancel.id}1`}>
                                <option value="" default>Choose Student</option>
                                {props.fam.listOfFamilyStudents.map((student) => (
                                    <option key={student.studentId} value={student.studentName}>{student.studentName}</option>
                                ))}
                                {/* {props.reviewing && <option value={cancel.student}>{cancel.student}</option>} */}
                                <option value="*">Enter Manually</option>
                            </select>
                            }
                            <div className="family-card__lesson-date go-red">{props.month}/<input value={cancel.date} id={`${cancel.id}2`} className="lesson-date-input go-red" />/22</div>
                            <select value={cancel.cancellor} id={`${cancel.id}4`} className="family-card__lesson-length cancellation-selector go-red">
                                <option default value="0">Cancelled by</option>
                                <option value="student">Student</option>
                                <option value="teacher">Teacher</option>
                                <option value="student less than 24hrs">Student&lt;24hr</option>
                            </select>
                            { cancel.cancellor === "student less than 24hrs" ?
                                <select id={`${cancel.id}3`} value={cancel.lessonLength} className="family-card__lesson-length popup-length-option go-red">
                                    <option default value={0}>Select Lesson Length</option>
                                    <option value="15">15 min</option>
                                    <option value="30">30 min</option>
                                    <option value="45">45 min</option>
                                    <option value="60">60 min</option>
                                </select>
                                :
                                null
                            }
                        </div>
                    )
                }
                {props.fam.extras.length > 0 && <div className="lesson-header">Extras</div>}
                {
                    props.fam.extras.map((extra, index2) => 
                        <div className="family-card__each-lesson-wrapper" key={extra.id}>
                            <input className="family-card__student-name" value={extra.description} placeholder="Description" id={`${extra.id}1`} />
                            <div className="family-card__lesson-date">$<input value={extra.amount} className="lesson-date-input" id={`${extra.id}2`} /></div>
                        </div>
                    )
                }
            </div>
        </div>
    )
}
export default FamilyCard;